import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Terminal, Home, Loader2, Lock, ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
export const SetupsPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="relative min-h-screen bg-hpmDarker flex flex-col items-center justify-center font-sans">
      {/* Scratched Grid Overlay */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, #F97316 1.5px, transparent 0)', backgroundSize: '30px 30px' }} />
      <div className="relative z-10 max-w-2xl w-full px-6 text-center">
        <motion.header 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12"
        >
          <h1 className="text-5xl md:text-7xl font-black italic tracking-tighter uppercase mb-4 text-white/10 group select-none">
            HPM <span className="text-orange-500 drop-shadow-[0_0_15px_rgba(249,115,22,0.4)]">SETUPS</span>
          </h1>
          <div className="flex items-center justify-center gap-2 text-[10px] font-black uppercase tracking-[0.4em] text-orange-500/50 italic">
            <Lock className="w-3 h-3" /> Secure Access Required
          </div>
        </motion.header>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.3 }}
        >
          <Card className="bg-hpmDark/60 border-orange-500/20 backdrop-blur-2xl overflow-hidden shadow-2xl">
            <div className="h-1 w-full bg-orange-500/30" />
            <CardContent className="p-12 flex flex-col items-center">
              <div className="relative mb-8">
                <Loader2 className="w-16 h-16 text-orange-500/20 animate-spin" />
                <ShieldAlert className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6 text-orange-500/40" />
              </div>
              <motion.h2 
                animate={{ opacity: [0.4, 1, 0.4] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="text-2xl font-black uppercase italic tracking-tighter text-orange-400 mb-6"
              >
                Conteúdo ainda em desenvolvimento
              </motion.h2>
              <div className="space-y-4 max-w-sm">
                <p className="text-[11px] font-black uppercase tracking-[0.2em] text-muted-foreground/40 italic leading-relaxed">
                  The HPM Nascar Setup Database is currently being optimized for the next competitive season. 
                  Encrypted telemetry packets are pending clearance.
                </p>
                <div className="flex flex-col gap-2 pt-6">
                  <div className="flex items-center gap-3 px-4 py-2 rounded bg-orange-500/5 border border-orange-500/10 text-[9px] font-black text-orange-500/60 italic uppercase tracking-widest">
                    <Terminal className="w-3 h-3" /> SYSTEM_STATUS: STANDBY_MODE
                  </div>
                  <div className="flex items-center gap-3 px-4 py-2 rounded bg-orange-500/5 border border-orange-500/10 text-[9px] font-black text-orange-500/60 italic uppercase tracking-widest">
                    <Terminal className="w-3 h-3" /> UPLINK_QUEUE: 0042_NASCAR_NG
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="mt-12"
        >
          <Button 
            onClick={() => navigate('/')}
            variant="outline"
            className="border-white/10 text-white/40 hover:bg-white/5 hover:text-white font-black italic uppercase tracking-[0.3em] gap-2 py-6 px-10 rounded-xl"
          >
            <Home className="w-4 h-4" />
            Return to Base
          </Button>
        </motion.div>
      </div>
    </div>
  );
};